import { ThrottleMessage } from "../components/ThrottleMessage";
import { Level } from "../state/mainGui";

export const actOnApiError = (
  error: Response,
  sendMessageFunction: (message: string | JSX.Element, timeoutMs: number, level?: Level) => void,
  _optionalCallback: () => void
) => {
  if (
    // check for throttling as here https://github.com/nens/threedi-live-site/issues/894
    error.statusText === "Too Many Requests" &&
    error.status === 429
  ) {
    error.json().then((_body) => {
      //const detail = body.detail;
      //const seconds = parseInt(((detail.split("available in ")[1]) || '').split(' seconds.')[0]);
      //const adaptedSeconds = seconds ? seconds + 3 : 3;
      sendMessageFunction(
        <ThrottleMessage />,
        // adaptedSeconds,
        // For now show this message for eternity, but once retry is fixed (https://github.com/nens/threedi-live-site/issues/894) use 'adaptedSeconds'
        60 * 60 * 24,
        "warning"
      );

      // Currently no not yet retry the callback, try to fix this later:
      // https://github.com/nens/threedi-live-site/issues/894
      // window.setTimeout((function () {
      //   optionalCallback()
      // }),adaptedSeconds*1000)
    });
  }
};

export const simulationIdFromUrl = (url: string): number => {
  const parts = url.split("/").filter((part) => !!part);
  return parts.length ? Number(parts[parts.length - 1]) : 0;
};
